<mat-form-field class="pr-3">
  <mat-label>Associated Company</mat-label>
  <input
    matInput
    [formControl]="associatedCompanyControl"
    [placeholder]="'Start typing...'"
    [matAutocomplete]="matAutocompleteCompany"
    [spellcheck]="false"
    [readonly]="readonly"
  />
  <ng-container *ngIf="isAssociatedCompanySearching">
    <div [ngTemplateOutlet]="LoadingSpinner"></div>
  </ng-container>
</mat-form-field>
<mat-autocomplete
  #matAutocompleteCompany="matAutocomplete"
  [disableRipple]="true"
  (optionSelected)="autocompleteAssociatedCompanySelected($event)"
>
  <mat-option *ngIf="associatedCompanyResults && !associatedCompanyResults.length" disabled>
    No results found. You can only associate contact to existing companies.
  </mat-option>

  <mat-option *ngFor="let associatedCompanyResult of associatedCompanyResults" [value]="associatedCompanyResult">
    {{ associatedCompanyResult }}
  </mat-option>
</mat-autocomplete>

<ng-template #LoadingSpinner>
  <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
</ng-template>
